import { TEAMS } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

export const teamsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getTeams: build.query({
      query: (params = {}) => ({
        url: TEAMS.BASE,
        method: 'GET',
        params: {
          'relations[0]': 'members',
          'relations[1]': 'status',
          paginate: 0,
          ...params,
        },
      }),
      providesTags: (result) => listTags('Team', result),
    }),
    getTeamById: build.query({
      query: (id) => ({
        url: TEAMS.BY_ID(id),
        method: 'GET',
        params: {
          'relations[0]': 'members',
          'relations[1]': 'status',
        },
      }),
      providesTags: (_r, _e, id) => [{ type: 'Team', id }],
    }),
    createTeam: build.mutation({
      query: (body) => ({ url: TEAMS.BASE, method: 'POST', data: body }),
      invalidatesTags: [{ type: 'Team', id: 'LIST' }],
    }),
    updateTeam: build.mutation({
      query: (arg) => {
        const id = arg?.id ?? arg?.teamId;
        const body = arg?.teamData ?? (() => {
          const { id: _i, teamId: _t, teamData: _d, ...rest } = arg || {};
          return rest;
        })();
        return {
          url: TEAMS.BY_ID(id),
          method: 'PUT',
          data: body,
        };
      },
      invalidatesTags: (_r, _e, arg) => {
        const id = arg?.id ?? arg?.teamId;
        return [
          { type: 'Team', id },
          { type: 'Team', id: 'LIST' },
        ];
      },
    }),
    deleteTeam: build.mutation({
      query: (id) => ({ url: TEAMS.BY_ID(id), method: 'DELETE' }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'Team', id },
        { type: 'Team', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetTeamsQuery,
  useLazyGetTeamsQuery,
  useGetTeamByIdQuery,
  useLazyGetTeamByIdQuery,
  useCreateTeamMutation,
  useUpdateTeamMutation,
  useDeleteTeamMutation,
} = teamsApi;
